var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3C91D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 18.1111V17.3333H7.808L7.8 20.4444C7.8 21.3078 8.512 22 9.4 22H20.6C21.488 22 22.2 21.3078 22.2 20.4444V17.3333H16.6V18.1111H13.4ZM21.4 11.1111H18.192V9.55556L16.592 8H13.392L11.792 9.55556V11.1111H8.6C7.72 11.1111 7 11.8111 7 12.6667V15C7 15.8633 7.712 16.5556 8.6 16.5556H13.4V15H16.6V16.5556H21.4C22.28 16.5556 23 15.8556 23 15V12.6667C23 11.8111 22.28 11.1111 21.4 11.1111ZM16.6 11.1111H13.4V9.55556H16.6V11.1111Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.401625c4e883e7c425fb0143b8013eb6.svg";
export { ForwardRef as ReactComponent };